/**
 * Session Expiration Service
 * Handles session expiration detection and notification
 */

let sessionExpiredCallbacks: Array<() => void> = [];

/**
 * Register a callback to be invoked when session expires
 * @param callback Function to call when session expires
 */
export const onSessionExpired = (callback: () => void): void => {
  sessionExpiredCallbacks.push(callback);
};

/**
 * Trigger all session expired callbacks
 */
export const notifySessionExpired = (): void => {
  sessionExpiredCallbacks.forEach((callback, index) => {
    try {
      callback();
    } catch (error) {
      console.error('[SessionExpirationService] Error in callback:', error);
    }
  });
};

/**
 * Clear a specific session expired callback
 * @param callback The callback to remove
 */
export const clearSessionExpiredCallback = (callback?: () => void): void => {
  if (callback) {
    sessionExpiredCallbacks = sessionExpiredCallbacks.filter(cb => cb !== callback);
  } else {
    // Clear all callbacks if no specific callback provided
    sessionExpiredCallbacks = [];
  }
};
